export * from './templates.page';
export * from './templates.page.resolver';
